const route = [
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state('authenticated.home', {
      url: 'home',
      component: 'tctHome',
      resolve: {
        auth: ['actionsFactory',
          '$ngRedux',
          (actionsFactory, $ngRedux) => {
            const state = $ngRedux.getState();
            const authenticated = state.authentication && state.authentication.isAuthenticated;
            if (authenticated) {
              $ngRedux.dispatch(
                actionsFactory.state(state.navigation.home.state, state.navigation.home.params));
            }
          }],
      },
    });
  },
];

export { route as default };
